import axios from 'axios';
import { ElLoading } from 'element-plus';
import { setShortToken, removeToken } from '@/utils/auth';
import errorCode from '@/utils/errorCode';
import { tansParams, blobValidate } from '@/utils/ruoyi';
import { saveAs } from 'file-saver';
// import { tryHideFullScreenLoading,showFullScreenLoading } from './appLoading.js'
import { isApp, getAppData, callNativeFn } from '@/utils/appTools';
import { showToast } from 'vant';
import router, {baseUrl} from '@/router/index'
let downloadLoadingInstance;

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: import.meta.env.VITE_APP_BASE_API,
  // 超时
  timeout: 6000000000,
});

// request拦截器
service.interceptors.request.use(
  (config) => {
    // const { proxy } = getCurrentInstance();
    //全局loading
    // showFullScreenLoading()
    if(!config.hideLoading){
       window?.$appLoading?.show();
    }
    // app嵌入使用短token
    if (isApp()) {
      const { deviceType, deviceId, Authorization } = getAppData();

      config.headers['device-type'] = deviceType;
      config.headers['device-id'] = deviceId;
      // app嵌入没有长token 使用短token
      config.headers['Authorization'] = Authorization;
    }
    // get请求映射params参数
    if (config.method === 'get' && config.params) {
      let url = config.url + '?' + tansParams(config.params);
      url = url.slice(0, -1);
      config.params = {};
      config.url = url;
    }
    return config;
  },
  (error) => {
    console.log(error);
    Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  async (res) => {
    // const { proxy } = getCurrentInstance();
    const { config } = res;
    if (config?.original) {
      return res;
    }
    // tryHideFullScreenLoading()
    window?.$appLoading?.hide();
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    const msg = res.data.msg || '未知异常';
    // 二进制数据则直接返回
    if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
      return res.data;
    }
    if (code === 401 || msg == '用户未登录') {
      if (isApp()) {
        removeToken();
        try {
          const res = await callNativeFn({ methodName: 'getShortToken' });
          if (res.data) {
            setShortToken(res.data);
            return service(config);
          }
        } catch (e) {}
      } else {
        const cur = location.pathname + location.search
        const fullPath = cur.substring(cur.indexOf(baseUrl) + baseUrl.length)
        router.push({
          path: '/h5/login',
          replace: true,
          query: {
            redirect: encodeURIComponent(fullPath)
          }
        });
      }
    } else if (code !== 200) {
      if (config.errorHandler) {
        config.errorHandler({
          ...res.data,
          errMsg: msg,
        });
      } else {
        if(!config.showToast){
          showToast(msg);
        }
      }
      
      return Promise.reject(res.data);
    } else {
      return Promise.resolve(res.data);
    }
  },
  (error) => {
    console.log('err' + error);
    let { message } = error;
    if (message == 'Network Error') {
      message = '后端接口连接异常';
    } else if (message.includes('timeout')) {
      message = '系统接口请求超时';
    } else if (message.includes('Request failed with status code')) {
      message = '系统接口' + message.substr(message.length - 3) + '异常';
    }
    showToast(message);
    window?.$appLoading?.hide();
    return Promise.reject(error);
  }
);

// 通用下载方法
export function download(url, params, filename, config) {
  downloadLoadingInstance = ElLoading.service({
    text: '正在下载数据，请稍候',
    background: 'rgba(0, 0, 0, 0.7)',
  });
  return service
    .post(url, params, {
      transformRequest: [
        (params) => {
          if (config && config.headers) {
            //JSON数据
            return JSON.stringify(params);
          } else {
            //formData数据
            return tansParams(params);
          }
        },
      ],
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      responseType: 'blob',
      ...config,
    })
    .then(async (data) => {
      const isBlob = blobValidate(data);
      if (isBlob) {
        const blob = new Blob([data]);
        saveAs(blob, filename);
      } else {
        const resText = await data.text();
        const rspObj = JSON.parse(resText);
        const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode['default'];
        showToast(errMsg);
      }
      downloadLoadingInstance.close();
    })
    .catch((r) => {
      console.error(r);
      showToast('下载文件出现错误，请联系管理员！');
      downloadLoadingInstance.close();
    });
}

//get 请求通用方法url
export function getAction(url, parameter) {
  if (Object.prototype.toString.call(parameter) == '[object Object]') {
    return service({
      url: url,
      method: 'get',
      params: parameter,
    });
  } else {
    url = parameter ? url + '/' + parameter : url;
    return service({
      url: url,
      method: 'get',
    });
  }
}

//post请求通用方法
export function postAction(url, parameter) {
  return service({
    url: url,
    method: 'post',
    data: parameter,
  });
}
//post application/x-www-form-urlencoded通用方法
export function postFormDataAction(url, parameter) {
  const formData = new FormData();
  for (let key in parameter) {
    formData.append(key, `${parameter[key]}`);
  }
  return service({
    url: url,
    method: 'post',
    data: formData,
  });
}

//put请求通用方法
export function putAction(url, parameter) {
  return service({
    url: url,
    method: 'put',
    data: parameter,
  });
}
//post application/x-www-form-urlencoded通用方法
export function putFormDataAction(url, parameter) {
  const formData = new FormData();
  for (let key in parameter) {
    formData.append(key, `${parameter[key]}`);
  }
  return service({
    url: url,
    method: 'put',
    data: formData,
  });
}

//delete 请求通用方法
export function deleteAction(url, parameter) {
  return service({
    url: url + '/' + parameter,
    method: 'delete',
  });
}

export default service;
